import { useEffect, useState } from "react";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import { parseHtml } from "../../utils/utils";
import WDMPTDGGrid from "../../components/wdmptdg/wdmptdg-grid";

const WDMPTDGPage = () => {
    const [wDMPTDGPage, setWDMPTDGPage] = useState();
    const [infoBlocks, setInfoBlocks] = useState([]);
    const [buttonCardsComponent, setButtonCardsComponent] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const webpage = await getDataFromCmsApi("webpage/whereDoMyPropertyTaxDollarsGo");
        const infoBlocks = webpage?.components?.filter((component) => !component.items);
        const buttonCardsComponent = webpage?.components?.filter((component) => component.items)[0]?.items;

        setWDMPTDGPage(webpage);
        setInfoBlocks(infoBlocks);
        setButtonCardsComponent(buttonCardsComponent);
    };

    return (
        <div className="container overflow-hidden py-5">
            <Stack spacing={2} direction="column" className="mb-4">
                <Typography variant="h2" className="text-center">
                    {wDMPTDGPage?.pageTitle}
                </Typography>

                <Stack spacing={2} className="py-4">
                    {infoBlocks?.map((item, index) => (
                        <Alert
                            key={index}
                            variant="outlined"
                            severity="info"
                            sx={{
                                fontSize: { xs: "14px", lg: "medium" },
                                padding: { xs: 2, lg: 4 },
                                paddingBottom: { xs: 0, lg: 2 },
                                borderRadius: 2
                            }}
                        >
                            <AlertTitle sx={{ fontSize: { xs: "medium", lg: "large" } }}>
                                {item.title}
                            </AlertTitle>
                            {parseHtml(item.description)}
                        </Alert>
                    ))}
                </Stack>

                {buttonCardsComponent?.length > 0 && <WDMPTDGGrid buttonCardsComponent={buttonCardsComponent} />}
            </Stack>
        </div>

    );
};

export default WDMPTDGPage;
